import React from 'react';

const StaticMap = ({ latitude, longitude, width = 300, height = 180 }) => {
  if (!latitude || !longitude) return null;

  const src = `https://www.openstreetmap.org/export/embed.html?bbox=${longitude - 0.005}%2C${latitude - 0.003}%2C${parseFloat(longitude) + 0.005}%2C${parseFloat(latitude) + 0.003}&layer=mapnik&marker=${latitude}%2C${longitude}`;

  return (
    <div style={{ borderRadius: '8px', overflow: 'hidden', border: '1px solid #e5e7eb' }}>
      <iframe
        title="Delivery Location"
        width={width}
        height={height}
        style={{ border: 0, display: 'block' }}
        src={src}
        loading="lazy"
      />
    </div>
  );
};

export default StaticMap;
